import { createFileRoute } from '@tanstack/react-router';

import { Landing } from '#features/landing/components/Landing';
import { landingRouteHead, landingRouteLoader } from '#features/landing/utils/landingRoute';

const gameSlug = 'wardogs';

export const Route = createFileRoute('/{-$locale}/_layout/_landing/wardogs')({
  component: () => <Landing gameSlug={gameSlug} />,
  loader: ({ context }) => landingRouteLoader(context.queryClient, gameSlug),
  head: ({ loaderData, params }) => landingRouteHead(gameSlug, loaderData, params.locale),
});
